import { createCRUDHook } from './createCRUDHook';
import { EstimateItemGroupDto } from 'utils/models';
import { CRM_CUSTOMER_ESTIMATE_ITEM_GROUPS } from './apiEndPoints';

const { Context, useManager, useConsumer } =
  createCRUDHook<EstimateItemGroupDto>({
    entityName: 'EstimateItemGroup',
    endpoint: CRM_CUSTOMER_ESTIMATE_ITEM_GROUPS,
  });

export const EstimateItemGroupContext = Context;
export const useEstimateItemGroupManager = useManager;
export const useEstimateItemGroup = useConsumer;
